import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SystemIcon } from '@monorepo/nova-icons';
import { StyledDivider, StyledHeaderContainer } from '../styled';
import { HoldRatioBadge } from './hold-ratio-badge';

/**
 * Icon button with no padding for info icons
 */
const StyledInfoButton = styled(IconButton)({
  padding: 0,
});

/**
 * Styled title with icon container
 */
const StyledTitleContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

/**
 * Styled title text
 */
const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 500,
  lineHeight: 1.5,
  letterSpacing: '0.08px',
  color: theme.palette.text.primary,
}));

interface CardHeaderProps {
  ratio: number;
}

/**
 * Card Header Component
 * Displays the title, info tooltip, and hold ratio badge
 */
export const CardHeader: FC<CardHeaderProps> = ({ ratio }) => {
  const { t } = useTranslation('communityStats');

  return (
    <>
      <StyledHeaderContainer>
        <StyledTitleContainer>
          <StyledTitle>{t('winLossDuration.title')}</StyledTitle>
          <Tooltip title={t('winLossDuration.tooltip')} arrow placement="top">
            <StyledInfoButton size="small">
              <SystemIcon iconName="Info" size={24} color="inherit" />
            </StyledInfoButton>
          </Tooltip>
        </StyledTitleContainer>

        <HoldRatioBadge ratio={ratio} />
      </StyledHeaderContainer>

      <StyledDivider />
    </>
  );
};
